import { Box } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const LogoWrapper = styled(Box)`
  display: inline-block;
  color: black;
`;

const Logo = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
  color: currentColor;

  * {
    color: inherit;
    fill: currentColor;
  }
`;

interface Props {
  width?: string;
  height?: string;
}

const Wordmark = ({ width = '96px', height = '12.6px', ...props }: Props) => (
  <LogoWrapper as="span" width={width} height={height} {...props}>
    <Logo xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 63" aria-label="Betterment" role="img">
      <title>Betterment</title>
      <path d="M449.7 44.7c0 11.6 6.1 18 17.7 18 5 0 9-1 12.5-2.7l-3.5-11a13 13 0 0 1-6.1 1.6c-4.4 0-6.6-2.6-6.6-7.4V27.3h13.7V16.1h-13.8V.4L449.7 5v39.7z" />
      <path d="M358 33.6a10 10 0 0 1 9.8-7.4c4.5 0 8 2.6 9.3 7.4H358zm33.1 5c-.2-14-9.8-24-23.3-24-13.7 0-24 10.4-24 24 0 13 9.5 24 23.9 24 10.4 0 19.8-6.5 22.6-15.5h-13.5c-2 2.8-5 4.2-9.1 4.2-5 0-8.9-3.4-10-9h33.4v-3.6z" />
      <path d="M428.6 61.3h13.8V33.5c0-5.6-1.7-10.3-4.8-13.7a16.2 16.2 0 0 0-12.4-5.1 19 19 0 0 0-14.1 6V16h-14v45.3h14v-21c0-8.3 3.4-12.8 9.5-12.8 4.8 0 8 3.6 8 9v24.8z" />
      <path d="M324.2 61.3H338V34c0-11.8-6.8-19.2-16.9-19.2-6.7 0-12.2 2.7-16 7.8-3-5-8.1-7.8-14.5-7.8-5.6 0-10 1.9-13.3 5.7V16h-14v45.3h14V39.1c0-7.4 3-11.6 8.6-11.6 5.2 0 7.8 3 7.8 8.5v25.3h14V39.1c0-7.4 3.2-11.6 9-11.6 4.5 0 7.5 3.7 7.5 8.8v25z" />
      <path d="M225.6 61.3h13.9V47c0-12.6 5.7-17.7 14.8-17.7 2.3 0 3.8.3 3.8.3V15.8c-1-.3-1.9-.4-3.2-.4-6.7 0-11.7 3.3-15.4 9.7v-9h-14v45.2z" />
      <path d="M186.4 33.6a10 10 0 0 1 9.8-7.4c4.6 0 8.1 2.6 9.3 7.4h-19.1zm33.2 5c-.3-14-10-24-23.4-24-13.7 0-24 10.4-24 24 0 13 9.5 24 24 24 10.3 0 19.8-6.5 22.5-15.5h-13.5c-2 2.8-5 4.2-9 4.2-5 0-9-3.4-10-9h33.4v-3.6z" />
      <path d="M121.3 27.3h19.4v17.4c0 11.6 6 18 17.7 18 5 0 9-1 12.5-2.7l-3.6-11a13 13 0 0 1-6 1.6c-4.5 0-6.7-2.6-6.7-7.4V27.3h13.7V16.1h-13.7V.4L140.7 5v11h-19.4V.6L107.4 5v39.7c0 11.6 6 18 17.7 18 5 0 9-1 12.5-2.7L134 49a13 13 0 0 1-6 1.6c-4.5 0-6.7-2.6-6.7-7.4V27.3z" />
      <path d="M68.5 33.6a10 10 0 0 1 9.8-7.4c4.5 0 8.1 2.6 9.3 7.4H68.5zm33.1 5c-.2-14-9.8-24-23.3-24-13.7 0-24 10.4-24 24 0 13 9.5 24 23.9 24 10.4 0 19.8-6.5 22.6-15.5H87.3c-2 2.8-5 4.2-9.1 4.2-5 0-8.9-3.4-10-9h33.4v-3.6z" />
      <path d="M28.3 49.5H14V37.3h14.3c3.3 0 6.6 2.1 6.6 6.2 0 3.5-2.7 6-6.6 6zM14 13.6h12.5c4.6 0 6.6 3 6.6 6 0 4.3-3.4 6.3-6.6 6.3H14V13.6zM40.7 30S48 26.2 48 17c0-7.2-6.3-15.3-18.8-15.3H0v59.7h29.2c16 0 20.4-10 20.4-16.8 0-10.9-8.9-14.6-8.9-14.6z" />
    </Logo>
  </LogoWrapper>
);

export default Wordmark;
